import { createContext, useContext, useEffect, useState } from 'react';
import * as authApi from '../api/auth';

const AuthContext = createContext(null);

// Cố vấn (CV) có toàn quyền y hệt Giám đốc. Để mọi kiểm tra quyền ở FE (me.role === 'GD')
// đều áp dụng cho CV, ta quy đổi role hiệu lực = 'GD' và giữ displayRole = 'CV' để hiển thị.
function normalizeMe(m) {
  if (m && m.role === 'CV') return { ...m, role: 'GD', displayRole: 'CV' };
  return m;
}

export function AuthProvider({ children }) {
  const [me, setMeRaw] = useState(null);
  const setMe = (m) => setMeRaw(normalizeMe(m));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('ft_token');
    if (!token) {
      setLoading(false);
      return;
    }
    authApi
      .me()
      .then((res) => setMe(res.me))
      .catch(() => localStorage.removeItem('ft_token'))
      .finally(() => setLoading(false));
  }, []);

  async function login(user, pass) {
    const res = await authApi.login(user, pass);
    localStorage.setItem('ft_token', res.token);
    setMe(res.me);
    return res.me;
  }

  function logout() {
    localStorage.removeItem('ft_token');
    setMe(null);
  }

  return <AuthContext.Provider value={{ me, setMe, login, logout, loading }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
